import { FC } from "react";
import { Button } from "antd";
import { useLogout } from "../common/Hooks/useLogout";
import classes from "./InitAppError.module.css";
import { UnknownError } from "../common/UnknownError";

interface IInitAppProps {
  error: UnknownError;
  onRetry?: () => void;
}

const InitAppError: FC<IInitAppProps> = ({ error, onRetry }) => {
  const logout = useLogout();
  return (
    <div className={classes.container}>
      <div className={classes.title}>⚠ An unexpected error has occurred!</div>
      <div className={classes.message}>{typeof error === "string" ? error : JSON.stringify(error)}</div>
      <div className={classes.suggestion}>
        Retry loading the application, or sign out and sign in again.
      </div>
      {onRetry && <Button onClick={onRetry}>Retry</Button>}
      <Button className={classes["logout-button"]} onClick={() => logout()}>
        Log out
      </Button>
      <div>
        {"If this issue persists, please contact "}
        <a href="mailto:support@solargik.com">Solargik&apos;s support team</a>
      </div>
    </div>
  );
};
export default InitAppError;
